import React from 'react';
import api from '../../Api';

const useCategoryFilters = () => {
	const [categoryFilters, setCategoryFilters] = React.useState([]);
	const [isLoading, setIsLoading] = React.useState(true);
	let request;

	const saveCategoryFilters = data => {
		setCategoryFilters(data);
		setIsLoading(false);
	};

	React.useEffect(() => {
		const fetchCategoryFilters = async () => {
			try {
				request = api.cancelableGet(
					'/api/v1/affiliations/categoryFilterOptions',
				);
				const categoryFilters = await request.promise;
				saveCategoryFilters(categoryFilters);
			} catch (e) {
				console.error(e);
				setIsLoading(false);
			}
		};

		fetchCategoryFilters();

		return () => {
			api.revoke(request);
		};
	}, []);

	return { categoryFilters, isLoading };
};

export default useCategoryFilters;
